import SignupForm from "../../../components/SignupForm/SignupForm";

const Signup = () => {
  return <SignupForm />;
};

export default Signup;
